import React, { useContext } from 'react';
import { format } from 'date-fns';
import { Form } from 'react-router-dom';
import { AuthContext } from '../../../context/AuthProvider';
import toast from 'react-hot-toast';
import { Toaster } from 'react-hot-toast';


const BookingModal = ({ treatment, selectedDate, setTreatment, refetch }) => {
    const { name: treatmentName, slots } = treatment;

    const date = format(selectedDate, 'PP');
    const { user } = useContext(AuthContext)

    const handleFormSubmit = event => {
        event.preventDefault()
        const form = event.target;
        const name = form.name.value;
        const email = form.email.value;
        const phone = form.phone.value;
        const slot = form.slot.value;
        const date = form.date.value;
        const price = form.price.value;
        console.log(name, email, phone, slot, date,price)
        const booking = {
            appointmentDate: date,
            treatment: treatmentName,
            patient: name,
            price,
            slot,
            email,
            phone,
        }
        fetch('https://denticare-server-sumonhasan55.vercel.app/bookings', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(booking)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                if (data.acknowledged) {
                   
                   
                    alert('Booking successfully')
                    refetch()
                    setTreatment(null)
                }
                else{
                    alert(data.message)
                  
                    setTreatment(null)
                }



            })


    }
    return (
        <div>
            {/* The button to open modal */}

            {/* Put this part before </body> tag */}
            <input type="checkbox" id="booking-modal" className="modal-toggle" />
            <div className="modal">
                <div className="modal-box relative">
                    <label htmlFor="booking-modal" className="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
                    <h3 className="text-lg font-bold">{treatmentName}</h3>
                    <Form onSubmit={handleFormSubmit}>
                        <div className="grid grid-cols-1 gap-4">
                            <input type="text" placeholder="Type here" className="input input-bordered w-full" value={date} readOnly name="date" />
                            <div className="input-group ">
                                <select name='slot' className="select select-bordered w-full">
                                    {
                                        slots.map(slot => <option
                                            slot={slot}
                                        >
                                            {slot}
                                        </option>)
                                    }
                                </select>
                            </div>
                            <input type="text" placeholder="Name" className="input input-bordered w-full" defaultValue={user?.displayName} disabled name="name" />
                            <input type="email" placeholder="Email" className="input input-bordered w-full" defaultValue={user?.email} disabled name="email"  required/>
                            <input type="text" placeholder="Phone" className="input input-bordered w-full" name="phone" required />
                            <input type="text" placeholder="Price" className="input input-bordered w-full" defaultValue={user?.price} name="price" required />
                            <input className='btn  text-white' type="submit" />

                        </div>
                    </Form>

                </div>
            </div>

        </div>
    );
};

export default BookingModal;